import api from '../../api/api';
import axios from '../../api/axios';
import Vue from 'vue';
import config from '../../config/config';
import router from '../../router/index';

export default {
	state: () => ({
		isAnonymus: true,
		session: false,
		baseUrl: '',
		login: {},
		token: '',
		lang: 'es',
		selectedRol: ''
	}),
	mutations: {
		SET_LANG(state, lang) {
			state.lang = lang;
		},
		SET_SELECTED_ROL(state, selectedRol) {
			state.selectedRol = selectedRol;
		},
		SET_lOGIN(state, login) {
			state.login = login;
		},
		SET_BASE_URL(state, baseUrl) {
			state.baseUrl = baseUrl;
		},
		SET_SESSION(state, session) {
			state.session = session;
		},
		SET_IS_ANONYMUS(state, isAnonymus) {
			state.isAnonymus = isAnonymus;
		},
		SET_TOKEN(state, token) {
			state.token = token;
		},
		SET_SESSION(state, session) {
			state.session = session;
		},
		LOGIN_SUCCESSFULL(state, data) {
			state.login = data;
			state.token = data.jwt;
			state.session = true;
			axios.defaults.headers.common['Authorization'] = data.jwt;
		},
		LOGIN_ERROR(state) {
			state.login = {};
			state.token = '';
			state.session = false;
			axios.defaults.headers.common['Authorization'] = '';
		}
	},
	actions: {
		SET_IS_ANONYMUS({ commit }, payload) {
			return commit('SET_IS_ANONYMUS', payload);
		},
		LOGIN({ commit }, payload) {
			const body = {
				...payload
			};
			return api.login
				.post({ body })
				.then((res) => {
					window.localStorage.setItem(config.sessionLSKey, JSON.stringify(res.data));
					const isAnonymus = res.data.usr === config.anonymousUser;
					return Promise.all([
						commit('LOGIN_SUCCESSFULL', res.data),
						commit('SET_IS_ANONYMUS', isAnonymus),
						commit('SET_LANG', res.data.language)
					]);
				})
				.catch((err) => {
					console.log('LOGIN_ERROR', err);
					Vue.$toast.error(err.response.data.message);
					return commit('LOGIN_ERROR');
				});
		},
		LOGOUT({ commit, dispatch, state }) {
			return api.login
				.signout({})
				.then((res) => {
					window.localStorage.removeItem(config.sessionLSKey);
					window.localStorage.removeItem(config.workinRoleLSKey);

					return Promise.all([
						commit('SET_lOGIN', {}),
						commit('SET_TOKEN', ''),
						commit('SET_SESSION', false),
						commit('SET_SELECTED_ROL', null)
					]);
				})
				.then(() => {
					const startLogin = state.isAnonymus ? () => Promise.resolve() : () => dispatch('DO_ANONYMOUS_LOGIN');
					return startLogin();
				})
				.catch((err) => {
					return Promise.all([
						commit('SET_lOGIN', {}),
						commit('SET_TOKEN', ''),
						commit('SET_SESSION', false),
						commit('SET_SELECTED_ROL', null)
					]);
				});
		},
		SET_WORKING_ROLE({ commit }, role) {
			return api.login
				.setWorkingRole({ role })
				.then((res) => {
					window.localStorage.setItem(config.workinRoleLSKey, role);

					return commit('SET_SELECTED_ROL', role);
				})
				.catch((err) => {
					Vue.$toast.error(err.response.data.message);
					return commit('SET_SELECTED_ROL', null);
				});
		},
		SESSION_EXPIRED({ dispatch }) {
			window.localStorage.removeItem(config.sessionLSKey);
			router.go();
		},
		DO_ANONYMOUS_LOGIN({ dispatch }) {
			const params = {
				usr: config.anonymousUser,
				password: config.anonymousPass,
				client: config.clientName,
				persistent: false
			};
			return dispatch('LOGIN', params);
		},
		SET_LANG({ commit }, payload) {
			return commit('SET_LANG', payload);
		}
	},
	getters: {
		getIsAnonymus: (state) => state.isAnonymus,
		getSession: (state) => state.session,
		getBaseUrl: (state) => state.baseUrl,
		getLogin: (state) => state.login,
		getSelectedRol: (state) => state.selectedRol,
		getSelectedLang: (state) => state.lang
	}
};
